export default __webpack_public_path__ + "static/media/teachings.b3f314d2.svg";